import React from 'react'
import PropTypes from 'prop-types'
import WrappedDrawer from '@/components/WrappedDrawer'
import MaternityCenterOrderProfileContent from './MaternityCenterOrderProfileContent'

class OrderDetailDrawer extends React.Component {
  static propTypes = {
    baseProps: PropTypes.object,
    title: PropTypes.string,
    width: PropTypes.number
  }

  handleClose = () => {
    const { baseProps } = this.props
    const { onClose } = baseProps || {}
    if (onClose) {
      onClose()
    }
  }

  render() {
    const { children, baseProps, title } = this.props
    const { orderId, onClose } = baseProps || {}

    const baseComponent = (
      <MaternityCenterOrderProfileContent
        orderId={orderId}
      />
    )

    return (
      <WrappedDrawer
        children={children}
        baseProps={{ ...baseProps }}
        baseComponent={baseComponent}
        title={title || '订单详情'}
        width={900}
        footer={null}
        maskClosable={true}
        onClose={onClose || this.handleClose}
      />
    )
  }
}

export default OrderDetailDrawer

